import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CareerResponse } from '../career/models/career-response.model';
import { ObserversModule } from '@angular/cdk/observers';
import { Career } from '../career/models/career.model';
import { CareerDetailResponse } from '../career/models/career-detail-response.model';

@Injectable({
  providedIn: 'root'
})
export class CareerService {

  private apiUrl = environment.baseApiUrl + "/careers";

  constructor(private http: HttpClient) { }

  getCareers(page: number, limit: number, searchTerm: string = '', status: String = 'All'): Observable<CareerResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('status', status.toString())

    return this.http.get<CareerResponse>(this.apiUrl, { params });
  }

  getCareerById(careerId: number): Observable<Career> {
    return this.http.get<CareerDetailResponse>(`${this.apiUrl}/${careerId}`).pipe(
      map((response: CareerDetailResponse) => response.data)
    )
  }

}
